import React, { memo, useState } from "react";
import { CCollapse } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import { Trash } from "./../../../../assets/images/svg";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { assignKeywords, unassignKeyword } from "../redux/referralCategoriesSagas";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { Delete } from "./Delete";
import NoData from "../../../../components/noData/noData";

export const Info = memo(function Info({ referralCategoryId, canUnassign }) {
  const dispatch = useDispatch();

  const info = useSelector((state) => state.referralCategories.currentReferralInfo);
  const unassignedKeywords = useSelector((state) => state.referralCategories.unassignedKeywords);
  const [selectedReferral, setSelectedReferral] = useState(null);
  const [selectedUnassignedKeywords, setSelectedUnassignedKeywords] = useState([]);

  const onClose = () => setSelectedReferral(null);

  const primaryBtnHandler = () => {
    dispatch(
      unassignKeyword({
        referralCategoryId,
        ...selectedReferral
      })
    );
    onClose();
  };

  const onSave = () => {
    setSelectedUnassignedKeywords([]);
    dispatch(
      assignKeywords({
        referralCategoryId,
        selectedUnassignedKeywords
      })
    );
  };

  return (
    <>
      <CCollapse show>
        <div className="referral-categories__expanded">
          {info ? (
            <>
              {info.data.map(({ id, name, clientsCount }) => {
                return (
                  <div className="referral-categories__category" key={id}>
                    <div className="referral-categories__keyword">{name}</div>
                    <div className="referral-categories__count">{clientsCount}</div>
                    {canUnassign && (
                      <div className="group__el delete">
                        <span
                          className="group__icon"
                          onClick={() => setSelectedReferral({ id, name, clientsCount })}
                          title="Delete"
                        >
                          <Trash color="#FF0000" />
                        </span>
                      </div>
                    )}
                  </div>
                );
              })}
              {info.data.length === 0 && unassignedKeywords.length == 0 && <NoData size="" />}
              {unassignedKeywords.length > 0 && (
                <div className="referral-categories__dropdown">
                  <Dropdown
                    includeSelectAll
                    height={275}
                    haveOnSelectChange
                    placeholder="Select from unassigned list of keywords"
                    enableOnly
                    options={unassignedKeywords}
                    selectedFilters={selectedUnassignedKeywords}
                    numberDisplayed={1}
                    onSelectChange={setSelectedUnassignedKeywords}
                  />
                  <button className="button button--primary" onClick={onSave}>
                    Save
                  </button>
                </div>
              )}
            </>
          ) : (
            <LoadingAnimation uiLoader />
          )}
        </div>
      </CCollapse>
      {selectedReferral && (
        <Delete onClose={onClose} primaryBtnHandler={primaryBtnHandler}>
          Are you sure to delete <span className="text-bold">{selectedReferral.name}</span> keyword?
        </Delete>
      )}
    </>
  );
});
